export default "__VITE_ASSET__004e5792__"